<template>
  <sweet-modal ref="modal" icon="warning" hide-close-button>
    <p>
      <StrongI18n
        keypath="modals.download"
        :values="{propName: selectedTemplate.name}"
      />
    </p>
    <template #button>
      <button class="btn btn-default right-margin" @click="close">
        {{ $t('modals.close_button') }}
      </button>
      <button class="btn btn-primary" @click="download">
        {{ $t('modals.download_button') }}
      </button>
    </template>
  </sweet-modal>
</template>

<script>
import {mapActions} from 'vuex';
import {SweetModal} from 'sweet-modal-vue-3';
import StrongI18n from '../lang/StrongI18n.vue';

export default {
  name: 'DownloadTemplateModal',
  components: {
    SweetModal,
    StrongI18n
  },
  data() {
    return {
      selectedTemplate: {}
    };
  },
  methods: {
    ...mapActions(['downloadTemplate']),
    open(template) {
      this.selectedTemplate = template;
      this.$refs.modal.open();
    },
    close() {
      this.$refs.modal.close();
    },
    download() {
      this.$refs.modal.close();
      this.downloadTemplate(this.selectedTemplate);
    }
  }
};
</script>

<style scoped>
.right-margin {
  margin-right: 1em;
}
</style>
